import { keycloak } from './app/lib/keycloak';
import { setKeycloakInitStatus, setRoles } from './app/lib/keycloak/slice';
import { useAppDispatch, useAppSelector } from './app/lib/redux/hook';
import { KeycloakRouter } from './app/lib/router';
import { findMeUser } from './app/pages/auth/slice';
import ConsentPage from './app/pages/customer/consentPage';
import { SuccesfulPayment } from './app/pages/customer/payment/success';

function App() {

  const dispatch = useAppDispatch()
  const keycloakState = useAppSelector(state => state.secured)

  keycloak.onAuthSuccess = () => {
    dispatch(setRoles(keycloak.tokenParsed?.realm_access?.roles))
    dispatch(setKeycloakInitStatus('successfully'))
    dispatch(findMeUser());
  }

  keycloak.onAuthRefreshError = () => {
    keycloak.logout()
    keycloak.login()
  }

  return (
    <div>
      {keycloak.authenticated && <KeycloakRouter />}
      {window.location.pathname === '/consent' && <ConsentPage />}
      {window.location.pathname === '/success' && <SuccesfulPayment />}
    </div>
  );
}

export default App;
